import { Form, Formik, useFormikContext } from 'formik';
import i18n from '../../i18n';
import styles from '../EventSubmissionForm/EventSubmissionForm.module.scss';
import InputGroup from '../InputGroup';
import inputGroupStyles from '../InputGroup/InputGroup.module.scss';
import { InputGroupV2, PrevAndSubmitButtons } from './EventSubmissionFormV2';

const TypeStep = ({
    initialValues,
    validationSchema,
    categories,
    onClickPrev,
    onSubmit,
}) => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}>
            {() => {
                return (
                    <Form className={styles['EventSubmissionForm--V2']}>
                        <legend
                            className={
                                styles['EventSubmissionForm__SectionHeader'] +
                                ' ' +
                                styles[
                                    'EventSubmissionForm__SectionHeader--Required'
                                ]
                            }>
                            {i18n.t(
                                'EventSubmissionFormV2.sectionHeaderCategories'
                            )}
                        </legend>

                        <InputGroupV2
                            name="categories"
                            type="checkbox"
                            items={categories.map((x) => ({
                                ...x,
                                name: 'categories',
                            }))}
                        />

                        <MainCategorySelector items={categories} />

                        <SubcategorySelector categories={categories} />

                        <InputGroup
                            name="isFree"
                            type="checkbox"
                            modifiers={
                                inputGroupStyles['InputGroup--PlaceStep']
                            }
                            items={[
                                {
                                    label: i18n.t(
                                        'EventSubmissionForm.labels.isFree'
                                    ),
                                    name: 'isFree',
                                },
                            ]}
                        />

                        <PrevAndSubmitButtons onClickPrev={onClickPrev} />
                    </Form>
                );
            }}
        </Formik>
    );
};

const SubcategorySelector = ({ categories }) => {
    const { values } = useFormikContext();
    const selectedCategories = values.categories || [];
    const selectedMainCategory = values.mainCategory;

    let filteredSubcategories = [];

    if (selectedCategories.length > 1 && selectedMainCategory) {
        filteredSubcategories = categories
            .filter((category) => category.value === selectedMainCategory)
            .flatMap((category) => category.subcategories);
    } else if (selectedCategories.length === 1) {
        filteredSubcategories = categories
            .filter((category) => selectedCategories.includes(category.value))
            .flatMap((category) => category.subcategories);
    }

    return (
        <>
            {filteredSubcategories.length > 0 && (
                <>
                    <legend
                        className={
                            styles['EventSubmissionForm__SectionHeader']
                        }>
                        {i18n.t(
                            'EventSubmissionFormV2.sectionHeaderSubCategory'
                        )}
                    </legend>
                    <InputGroupV2
                        name="subcategory"
                        type="radio"
                        items={filteredSubcategories.map((subcategory) => ({
                            ...subcategory,
                            name: 'subcategory',
                        }))}
                    />
                </>
            )}
        </>
    );
};

const MainCategorySelector = ({ items }) => {
    const { values, setFieldValue } = useFormikContext();
    const numSelectedCategories = !!values.categories
        ? values?.categories?.filter(Boolean).length
        : 0;

    return (
        <div>
            {numSelectedCategories > 1 && (
                <>
                    <legend
                        className={
                            styles['EventSubmissionForm__SectionHeader'] +
                            ' ' +
                            styles[
                                'EventSubmissionForm__SectionHeader--Required'
                            ]
                        }>
                        {i18n.t(
                            'EventSubmissionFormV2.sectionHeaderMainCategory'
                        )}
                    </legend>
                    <InputGroupV2
                        name="mainCategory"
                        type="radio"
                        items={items
                            .filter(
                                (x) => values.categories.indexOf(x.value) > -1
                            )
                            .map((x) => {
                                return { ...x, name: 'mainCategory' };
                            })}
                        onChange={(e) => {
                            setFieldValue('mainCategory', e.target.value);
                        }}
                    />
                </>
            )}
        </div>
    );
};

export default TypeStep;
